import { useEffect, useState } from "react";
import { getChannels } from "../../../services/channel";
import { getDepartments } from "../../../services/departments";
import { getTagsByTake } from "../../../services/tags";

const OPTION_LIMIT = 100;

const byId = (items) => Object.fromEntries(items.map((item) => [item.id, item]));

// Departments, Live Chat sites (channels) and tags for filters and badges.
export const useLivechatOptions = (token, me) => {
  const [options, setOptions] = useState({ departments: {}, channels: {}, tags: [] });

  useEffect(() => {
    const departmentAccess = JSON.parse(localStorage.getItem("permission") || "{}")?.departments?.access ?? [];

    Promise.all([
      getDepartments(token, "", me.departmentIds.join(","), me.id, departmentAccess, OPTION_LIMIT),
      getChannels(token, 1, OPTION_LIMIT),
      getTagsByTake(token, "", OPTION_LIMIT, 1),
    ]).then(([departments, channels, tags]) => {
      setOptions({
        departments: byId(departments?.data?.data ?? []),
        channels: byId((channels?.data?.data ?? []).filter((channel) => channel.type === "livechat")),
        tags: tags?.data?.data ?? [],
      });
    });
  }, [token, me.id, me.departmentIds.join(",")]); // eslint-disable-line react-hooks/exhaustive-deps

  return options;
};
